var _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229 162.5C229 201.436 188.884 254 150.5 254C112.116 254 74 201.436 74 162.5C74 123.564 112.116 105 150.5 105C188.884 105 229 123.564 229 162.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M242.133 119.765C248.079 124.11 256.42 122.812 260.765 116.867C265.11 110.921 263.812 102.58 257.867 98.2348C251.921 93.89 243.58 95.1877 239.235 101.133C234.89 107.079 236.188 115.42 242.133 119.765ZM193.035 130.926C195.892 118.218 198.691 108.112 201.823 100.707C204.994 93.2077 208.293 89.0047 211.819 87.3459C215.13 85.7878 219.389 86.1621 225.457 89.8704C231.539 93.5871 238.952 100.378 248.135 110.665L251.865 107.335C242.598 96.9537 234.791 89.7142 228.064 85.604C221.324 81.4854 215.185 80.236 209.69 82.8217C204.409 85.3066 200.492 91.0149 197.217 98.7593C193.903 106.597 191.026 117.066 188.157 129.83L193.035 130.926Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1111 148.043C48.0566 152.388 56.3984 151.09 60.7432 145.145C65.088 139.199 63.7903 130.857 57.8449 126.513C51.8994 122.168 43.5575 123.465 39.2128 129.411C34.868 135.356 36.1656 143.698 42.1111 148.043ZM52.477 137.348C52.7905 126.262 53.5967 117.668 55.2883 111.66C57.001 105.578 59.3665 102.981 62.1873 102.331C65.308 101.611 70.1812 102.906 77.7171 107.831C85.1098 112.663 94.4992 120.604 106.403 132.043L109.867 128.438C97.9013 116.939 88.2434 108.738 80.4526 103.646C72.8049 98.6477 66.3582 96.2382 61.0641 97.4585C55.47 98.7481 52.3259 103.734 50.4755 110.305C48.6041 116.951 47.7938 126.078 47.479 137.207L52.477 137.348Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 173,
    r: 10,
    fill: "#FFFEFE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 173,
    r: 10,
    fill: "#FFFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.9dcc7ed48202afe7aa51fe4507233014.svg";
export { ForwardRef as ReactComponent };